<div>
  <ng-container *ngIf="!runners || runners.length === 0">
    <div class="runners no-runners">
      No runners found or loaded yet
    </div>
  </ng-container>

  <ng-container *ngIf="runners && runners.length > 0">
    <div *ngFor="let runner of runners" class="container-fluid">
      <div
        [ngClass]="{online: runner.online, offline: !runner.online, paused: runner.status === 'paused', active: runner.jobs?.length > 0}"
        class="runner row">
        <div class="col-12">
          {{runner.description}}
        </div>
        <ng-container *ngFor="let job of runner?.jobs">
          <div class="col-5">{{job.project.name_with_namespace}}</div>
          <div class="col-2">{{job.pipeline.id}}</div>
          <div class="col-5">{{job.name}}</div>
          <div *ngIf="job.commit" class="col-12 commit-message">{{job.commit.title}}</div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

